import loadable from '@wix/yoshi-flow-editor/loadable';
import {IProductQuickAddProps} from './ProductQuickAdd';

export const LazyProductQuickAdd = loadable<IProductQuickAddProps>(
  () => import(/* webpackChunkName: "LazyProductQuickAdd" */ './ProductQuickAdd'),
  {
    resolveComponent: (component) => component.ProductQuickAdd,
  }
);
